import { render, staticRenderFns } from "./ModalVinculosFormulario.vue?vue&type=template&id=766a2ee0&"
import script from "./ModalVinculosFormulario.vue?vue&type=script&lang=js&"
export * from "./ModalVinculosFormulario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports